<template>
  <section>
    <div class="flex justify-between items-center">
      <div class="text-sm font-bold">{{ standardRate.function_name }}</div>
      <p-toggle v-model="rowEnabled" :input-id="standardRate.function_id.toString()"/>
    </div>

    <p-form ref="standardRatesForm"
            :form-data="formData"
            :disable-form="!rowEnabled"
            :disable-buttons="true"/>

    <div class="text-xs grid grid-cols-2 gap-4">
      <div>Standaard tarief {{ formatPriceToEuroString(standardRate.rate) }}</div>
      <div>Standaard tarief {{ formatPriceToEuroString(standardRate.periodical_rate) }}</div>
    </div>

    <p-ruler class="my-4"/>
  </section>
</template>

<script setup lang="ts">
import { useFormFunctions } from '@pidz/shared/forms';
import { rerouteToOverview } from '@pidz/shared/utils';
import { useRatesStore } from '@pidz/stores';
import { formatPriceToEuroString } from '@pidz/utils';
import { computed, ref } from 'vue';
import { Router, useRouter } from 'vue-router';

const props = withDefaults(defineProps<{
  standardRate: Rate
  formData: PidzFormData<StandardRateForm>
  isEdit?: boolean,
  organisation: ComboBoxOption,
  department: ComboBoxOption 
}>(), {
  isEdit: false,
});

const router: Router = useRouter();

const ratesStore = useRatesStore();

const rowEnabled = ref(false);

const standardRatesForm = ref<any>();

const {
  isSubmitDisabled,
  isSubmitting,
  succesToaster,
  warnBeforeCancel,
} = useFormFunctions(
  standardRatesForm,
  [],
  () => rerouteToOverview(router, 'rates'),
  () => Promise.resolve(),
  props.isEdit,
  'Afwijkende tarieven',
);

const isValid = computed(() => standardRatesForm.value?.meta.valid && !standardRatesForm.value?.isValidating);

const onSubmit = async () => {
  const submit = standardRatesForm?.value?.handleSubmit(
    async (formValues: StandardRateForm) => {
      if (standardRatesForm.value?.isValidating || !standardRatesForm.value?.meta.valid) return;

      const editItem: Rate = {
        ...props.standardRate,
        rate: parseFloat(formValues.rate.replace(',', '.')),
        periodical_rate: parseFloat(formValues.periodical_rate.replace(',', '.')),
        organisation_id: props.organisation.value as number,
        department_id: props.department.value === -1 ? undefined : props.department.value as number,
      };
      
      await ratesStore.addFreelancerFunctionRate(editItem);
    },
  );

  if (submit) {
    await submit();
  }
};

const isChanged = computed(() => standardRatesForm.value?.meta.dirty);
const isChangedAndValid = computed(() => !isSubmitDisabled.value && rowEnabled);

defineExpose({
  isValid,
  isChanged,
  isChangedAndValid,
  isSubmitting,
  onSubmit,
  succesToaster,
  warnBeforeCancel,
});
</script>
